module.exports = __webpack_public_path__ + "img/introcover.86b406fb.webp";